import(/* webpackMode: "eager", webpackExports: ["ContactSection"] */ "/vercel/path0/app/(landing-page)/sections/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/app/(landing-page)/sections/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricesSection"] */ "/vercel/path0/app/(landing-page)/sections/PricesSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/celebration.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/CTA-backgroung.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/handshake.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/logo-secondary.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/logos/logo-tenup.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-agglo-beauvais.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-beauvais-capitale.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-fete-le-mur.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-fft.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-oise-departement.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-prefet-oise.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/partners/institutional/logo-region-hauts-de-france.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/sports_tennis.svg");
;
import(/* webpackMode: "eager", webpackExports: ["OurClubIntro"] */ "/vercel/path0/app/components/sections/OurClubIntro.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/sections/SectionTitlte.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
